export default __webpack_public_path__ + "static/media/E190.ee182865.jpg";